import React, { useState, useEffect } from "react";
import * as cTypes from 'config/ConfigTypes';
import { getAuthFormData, getFormHeading, handleActionsBottomBtn } from 'helpers/AuthHelper';
import { showElement, showActions, showCollapse } from 'components/Screen/Screen';
import { checkDependForDD } from 'helpers/MetadataHelper';
import "./RegisterForm.scss";

const RegisterForm = ({ formatMessage, authForm, errors, onBtnClick, onActionClick,
    configObjects, authObjects, updateAuthObjects, getInsts, loading, msg }) => {
    const [userInputs, setUserInputs] = useState(authObjects[`${authForm}`] || {});
    const [data, setData] = useState([]);
    const [boxState, setBoxState] = useState(false);
    const [boxData, setBoxData] = useState([]);
    const [isActive, setIsActive] = useState('');
    const [flexClasses, setFlexClasses] = useState({});
    const formHeading = getFormHeading({ authForm, formatMessage });
    let actions = handleActionsBottomBtn({ authForm });

    useEffect(() => {
        setAuthFormData();
        let formData = getAuthFormData({ authForm, configObjects, authObjects });
        setData(formData);
        getInsts();
    }, [authForm]);

    const setAuthFormData = () => {
        let updated = authObjects[`${authForm}`] ? authObjects[`${authForm}`] : {};
        if (authForm === cTypes.REGISTER_OVERVIEW
            || authForm === cTypes.REGISTER_APPLY) {
            updated = {};
            for (let i in authObjects) {
                if (i.includes("register_") && authObjects[i]) {
                    updated = { ...updated, ...authObjects[i] }
                }
            }
            updateAuthObjects({ [`${authForm}`]: updated });
        }
        if (authForm === cTypes.REGISTER_NEW_INST) {
            let created = cTypes.REGISTER_CREATE_INST;
            updated = authObjects[`${created}`] ? authObjects[`${created}`] : {};
        }
        setUserInputs(updated);
    }

    const updateAuthForm = (name, value) => {
        updateAuthObjects({ [`${authForm}`]: { ...authObjects[[`${authForm}`]], [name]: value } });
    }

    const onInput = (e, name) => {
        setUserInputs((prev) => {
            return ({ ...prev, [name]: e.target.value });
        });
        updateAuthForm(name, e.target.value);
    }


    const onBtn = (authForm) => () => {
        if (authForm.includes("register_inst_different_")
            || authForm.includes("register_user_different_")) {
            let buff = getAuthFormData({ authForm, configObjects, authObjects });
            if (!boxState) setIsActive(authForm);
            else setIsActive('');
            setBoxState(!boxState);
            setBoxData(buff);
        } else {
            onBtnClick({ authForm });
        }
    }

    const onDDCk = (el) => (ddItem) => {
        let isDepend = checkDependForDD({
            authObjects, entry: el, authForm,
            ddItem, updateAuthObjects, setUserInputs
        });
        if (!isDepend && authObjects && authObjects[el.originalname]
            && authObjects[el.originalname][ddItem.name]) {
            setUserInputs((prev) => {
                let updated = { ...prev, ...authObjects[el.originalname][ddItem.name], [`${el.name}`]: ddItem };
                if (authObjects[el.originalname][ddItem.name].id) {
                    updated[cTypes.USER_INST] = authObjects[el.originalname][ddItem.name].id;
                }
                return updated;
            });
            updateAuthObjects({
                [`${authForm}`]: {
                    ...authObjects[[`${authForm}`]], [el.name]: ddItem,
                    ...authObjects[el.originalname][ddItem.name]
                }
            });
        } else {
            setUserInputs((prev) => {
                return ({ ...prev, [`${el.name}`]: ddItem });
            });
            updateAuthForm(el.name, ddItem);
        }
    }

    const onCheckBox = (el) => (e) => {
        setUserInputs((prev) => {
            return ({ ...prev, [`${el.name}`]: e.target.checked ? true : false });
        });

        let value = e.target.checked ? true : false;
        updateAuthForm(el.name, value);
    }


    const addClasses = (obj) => {
        setFlexClasses({ ...flexClasses, ...obj });
    }
    const showContent = (dataArr) => {
        let fm = formatMessage;
        let dataObjects = authObjects;
        if (dataArr && dataArr.length > 0) {
            return dataArr.map((item, idx) => {
                let eObj = { el: item, idx, fm, onDDCk, onInput, onCheckBox, onBtn, userInputs, setUserInputs, dataObjects, errors, addClasses, flexClasses };
                let coObj = { el: item, idx, showContent, boxData, formatMessage, isActive, onBtn, boxState };
                if (item.type && item.type === cTypes.COLLAPSE) return showCollapse(coObj);
                if (item.type && (item.type === cTypes.TEXT_FROM_CHILDREN || item.type === cTypes.SPLIT)
                    && item.children && item.children.length > 0) {
                    return showElement(eObj);
                }
                if (item.children && item.children.length > 0) {
                    return (
                        <div className={`registerform-inactive ${item.inActive ? flexClasses[item.name] : ' registerform-row'}`}
                            key={`registerform-content-${item.name}`}>
                            {item.children.map((el, index) => showElement({ ...eObj, el: el, idx: index, isChild: true }))}
                        </div>
                    )
                }
                return showElement(eObj);
            })
        }
    }

    return (
        <div className="RegisterForm Screen">
            <div className="registerform-heading">
                <div className="registerform-buff" />
                {formHeading && formHeading}
            </div>
            <>
                {showContent(data)}
                {showActions({ actions, onActionClick, userInputs, formatMessage, loading, msg })}
            </>
        </div>
    )
}

export default RegisterForm;